<template>
  <div class="Wdgt-Search-Market">
    <SectionTitle class="Wdgt-Search-Market__hdr" :iconName="'market'">Рынок сейчас</SectionTitle>
    <div class="Wdgt-Search-Market__box-group">
      <div class="Wdgt-Search-Market__box Wdgt-Search-Market__box--green">
        <SectionTitle class="Wdgt-Search-Market__hdr-section" :iconName="'top'" :prefix="'24ч'" :isJustify="true">Лидеры роста</SectionTitle>
        <MarketNowStub v-for="index in 5" :key="index" v-if="props.isLoading"/>
        <ul class="Wdgt-Search-Market__list" v-else>
          <li v-for="coin in topGainCoins" :key="coin.symbol" class="Wdgt-Search-Market__item">
            <BlockProject :image="coin.image" :link="coin.dropstab_url" :name="coin.symbol" />
            <p class="Wdgt-Search-Market__price">
              ${{ coin.price_usd }} <span class="Wdgt-Search-Market__percent Wdgt-Search-Market__percent--green">{{ formatPercent(coin.change_1d_usd) }}</span>
            </p>
          </li>
        </ul>
      </div>
      <div class="Wdgt-Search-Market__box Wdgt-Search-Market__box--red">
        <SectionTitle class="Wdgt-Search-Market__hdr-section" :iconName="'loser'" :prefix="'24ч'" :isJustify="true">Лидеры падения</SectionTitle>
        <MarketNowStub v-for="index in 5" :key="index" v-if="props.isLoading"/>
        <ul class="Wdgt-Search-Market__list" v-else>
          <li v-for="coin in topLossCoins" :key="coin.symbol" class="Wdgt-Search-Market__item">
            <BlockProject :image="coin.image" :link="coin.dropstab_url" :name="coin.symbol" />
            <p class="Wdgt-Search-Market__price">
              ${{ coin.price_usd }} <span class="Wdgt-Search-Market__percent Wdgt-Search-Market__percent--red">{{ formatPercent(coin.change_1d_usd) }}</span>
            </p>
          </li>
        </ul>
      </div>
      <div class="Wdgt-Search-Market__box">
        <SectionTitle class="Wdgt-Search-Market__hdr-section" :iconName="'trend_nft'" :prefix="'7д'" :isJustify="true">Трендовые NFT на Blur</SectionTitle>
        <MarketNowStub v-for="index in 5" :key="index" v-if="props.isLoading"/>
        <ul class="Wdgt-Search-Market__list" v-else>
          <li v-for="collection in trendingNftCollections" :key="collection.id" class="Wdgt-Search-Market__item">
            <BlockProject :image="collection.image_url" :link="collection.blur_url" :isSquare="true" :name="collection.name" />
            <p class="Wdgt-Search-Market__price">
              {{ formatFloat(collection.floor_price_eth) }} <AvatarImage class="Wdgt-Search-Market__coin-icon" src="https://static.images.dropstab.com/images/ethereum.svg" :size="14" :alt="collection.name" />
              <span class="Wdgt-Search-Market__percent" :class="getPercentClass(collection.change_1w_percent)">{{ formatPercent(collection.change_1w_percent) }}</span>
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { Props } from './scripts/props.js';
  //---------------------------------------
  import AvatarImage from '@shared/UI/Images/AvatarImage/AvatarImage.vue';
  import BlockProject from '@ui/Blocks/BlockProject/BlockProject.vue';
  import SectionTitle from '@widgets/SearchWidget/details/SectionTitle/SectionTitle.vue';
  import MarketNowStub from './details/MarketNowStub.vue';
  //---------------------------------------
  const props = defineProps(Props());
  //---------------------------------------
  //Форматировать процент
  const formatPercent = (percent) => {
    if (percent === null) return 'N/A';
    else return `${percent.toFixed(2)}%`;
  };
  //Форматировать цену
  const formatFloat = (price) => {
    if (price === null || price === undefined) return 'N/A';
    return `${price.toFixed(2)}`;
  };
  //Определить класс для процента
  const getPercentClass = (percent) => {
    return percent >= 0 ? 'Wdgt-Search-Market__percent--green' : 'Wdgt-Search-Market__percent--red';
  };

</script>

<style lang="scss">
  @import "./styles/_conf";
</style>
